import { useState, useEffect, ReactElement } from "react";

const ClientOnly: React.FC = ({ children }) => {
  const [shouldRender, setShouldRender] = useState(false);
  useEffect(() => {
    setShouldRender(true);
  }, []);

  return shouldRender ? (children as ReactElement) : null;
};

export default ClientOnly;
